<template>
  <tr>
    <td data-label="Name">
      <router-link :to="{ path: contractor.uuid, append: true }" >
        <strong>
          {{ contractor.dropdownLabel }}
        </strong>
      </router-link>
    </td>
    <td data-label="Email">
      {{ contractor.email }}
    </td>
    <td data-label="Phone">
        {{ contractor.mobilePhone ? contractor.mobilePhone : 'N/A' }}
    </td>
    <td data-label="Address">
        {{ contractor.address ? contractor.address : 'N/A' }}
    </td>
    <td data-label="Agreement Status">
        <span :class="termsStatus.class" class="badge">
          {{ termsStatus.text }}
        </span>
    </td>
    <td class="button-3 text-center">
      <button class="my-2 btn btn-warning" @click="editContractorMember()">
        <i class="fa fa-edit" /> Edit
      </button>
      <button class="my-2 btn btn-danger" @click="deleteContractorMember()">
        <i class="fa fa-trash" /> Delete
      </button>
      <router-link v-if="isTOEPdfExist"
        target="_blank"
        :to="{ path: '/api/public/pdf/' + contractor.ContractorAccount.uuid + '?m=IndividualContractorTOE' }"
        class="my-1 btn btn-info">
        <i class="fa fa-fw fa-eye" /> TOE Preview
      </router-link>
    </td>
  </tr>
</template>

<script>
export default {
  name: 'ContractorRow',
  props: {
    object: {
      type: Object
    },
    index: {
      type: Number
    }
  },
  computed: {
    isTOEPdfExist () {
      return Boolean(this.contractor.ContractorAccount && this.contractor.ContractorAccount.IndividualContractorTOE)
    },
    phone () {
      if (this.contractor.phone) {
        return this.contractor.phone.replace(/\D/g, '')
      } else {
        return ''
      }
    },
    contractor () {
      return {
        AccountType: {},
        ...this.object
      }
    },
    termsStatus () {
      let status = { class: 'badge-danger', text: 'Not Signed' }
      if (this.contractor.ContractorAccount && this.contractor.ContractorAccount.termsAgreed) {
        status = { class: 'badge-success', text: 'Signed' }
      }
      return status
    }
  },
  methods: {
    editContractorMember () {
      this.$emit('edit', { permalink: 'editContractor', uuid: this.contractor.uuid })
    },
    deleteContractorMember () {
      this.$emit('deleteObject', { permalink: 'deleteContractor', uuid: this.contractor.uuid })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/rows/ContractorRow.vue